import firebase from 'firebase';
import * as Firebase from '../config.js';

export default {
  store(stock){

  },

  get(symbol){
    return Firebase.stocks.child(symbol).once('value');
  },

  setStarred(symbol, starred){
    return Firebase.stocks.child(symbol + '/starred').set(starred);
  }
}



// WEBPACK FOOTER //
// ./src/helpers/Stock.js